import { useAppSelector } from 'store/hooks'

import { ScreenModeType } from './types'

export const useScreenMode = (): ScreenModeType =>
  useAppSelector(state => state.screenMode)

export const useScreen = () => useAppSelector(state => state.screenMode.screen)
